import React from "react";
import { motion } from "framer-motion";
import { MemoryRouter } from "react-router-dom";
import styles from "./Emailtocase.module.scss";

// --- Centralized Exhaustive SVG Icons (Unified to Primary Color) ---
const Icons = {
  Check: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  ),
  ArrowRight: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <line x1="5" y1="12" x2="19" y2="12"></line>
      <polyline points="12 5 19 12 12 19"></polyline>
    </svg>
  ),
  ArrowDown: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <line x1="12" y1="5" x2="12" y2="19"></line>
      <polyline points="19 12 12 19 5 12"></polyline>
    </svg>
  ),
  Link: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
    </svg>
  ),
  Graph: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
    </svg>
  ),
  Clock: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="12 6 12 12 16 14"></polyline>
    </svg>
  ),
  FileText: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="16" y1="13" x2="8" y2="13"></line>
      <line x1="16" y1="17" x2="8" y2="17"></line>
      <polyline points="10 9 9 9 8 9"></polyline>
    </svg>
  ),
  Laptop: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
      <line x1="8" y1="21" x2="16" y2="21"></line>
      <line x1="12" y1="17" x2="12" y2="21"></line>
    </svg>
  ),
  Shield: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    </svg>
  ),
  Settings: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <circle cx="12" cy="12" r="3"></circle>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
    </svg>
  ),
  TrendingUp: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
      <polyline points="17 6 23 6 23 12"></polyline>
    </svg>
  ),
  Inbox: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline>
      <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>
    </svg>
  ),
  Search: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  ),
  Tag: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
      <line x1="7" y1="7" x2="7.01" y2="7"></line>
    </svg>
  ),
  Send: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <line x1="22" y1="2" x2="11" y2="13"></line>
      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
    </svg>
  ),
};

// --- Animations ---
const parentVariants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.1 } },
};
const childVariants = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
  },
};

// --- Custom Email To Case Hero Art ---
const EmailHeroArt = () => (
  <div className="product-hero-art" aria-hidden>
    <div className="product-hero-art-glow" />
    <svg
      className="product-hero-svg"
      viewBox="0 0 440 380"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter id="hero-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="8" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Decorative Grid */}
      <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
        <path
          d="M 40 0 L 0 0 0 40"
          fill="none"
          stroke="rgba(79, 70, 229, 0.08)"
          strokeWidth="1"
        />
      </pattern>
      <rect width="100%" height="100%" fill="url(#grid)" />

      {/* Connection Lines */}
      <path
        d="M 80 120 C 140 120, 160 190, 220 190"
        stroke="#4f46e5"
        strokeWidth="2"
        strokeDasharray="4 4"
        className="anim-dash"
      />
      <path
        d="M 80 260 C 140 260, 160 190, 220 190"
        stroke="#4f46e5"
        strokeWidth="2"
        strokeDasharray="4 4"
        className="anim-dash"
      />
      <path
        d="M 220 190 L 340 190"
        stroke="#4f46e5"
        strokeWidth="2"
        strokeDasharray="4 4"
        className="anim-dash"
      />

      {/* Input Envelopes */}
      <g className="anim-float" style={{ animationDelay: "0s" }}>
        <rect
          x="30"
          y="100"
          width="50"
          height="34"
          rx="4"
          fill="rgba(79, 70, 229, 0.15)"
          stroke="#4f46e5"
          strokeWidth="1.5"
        />
        <polyline
          points="30,100 55,120 80,100"
          fill="none"
          stroke="#4f46e5"
          strokeWidth="1.5"
        />
      </g>
      <g className="anim-float" style={{ animationDelay: "0.4s" }}>
        <rect
          x="30"
          y="240"
          width="50"
          height="34"
          rx="4"
          fill="rgba(79, 70, 229, 0.15)"
          stroke="#4f46e5"
          strokeWidth="1.5"
        />
        <polyline
          points="30,240 55,260 80,240"
          fill="none"
          stroke="#4f46e5"
          strokeWidth="1.5"
        />
      </g>

      {/* Central AI Processor */}
      <g className="anim-pulse-box">
        <circle
          cx="220"
          cy="190"
          r="40"
          fill="rgba(15, 23, 42, 0.8)"
          stroke="#4f46e5"
          strokeWidth="2"
          filter="url(#hero-glow)"
        />
        <path
          d="M205 190 A15 15 0 1 1 235 190 A15 15 0 1 1 205 190"
          stroke="#a5b4fc"
          strokeWidth="3"
          className="anim-spin-slow"
          style={{ transformOrigin: "220px 190px" }}
        />
        <circle cx="220" cy="190" r="6" fill="#a5b4fc" />
      </g>

      {/* Output Structured Data / Case */}
      <g className="anim-float" style={{ animationDelay: "0.2s" }}>
        <rect
          x="340"
          y="150"
          width="70"
          height="80"
          rx="6"
          fill="rgba(79, 70, 229, 0.2)"
          stroke="#4f46e5"
          strokeWidth="2"
        />
        <line
          x1="350"
          y1="165"
          x2="380"
          y2="165"
          stroke="#a5b4fc"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <line
          x1="350"
          y1="180"
          x2="400"
          y2="180"
          stroke="#4f46e5"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <line
          x1="350"
          y1="195"
          x2="390"
          y2="195"
          stroke="#4f46e5"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <line
          x1="350"
          y1="210"
          x2="385"
          y2="210"
          stroke="#4f46e5"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </g>

      {/* Status Indicators */}
      <rect
        x="250"
        y="110"
        width="70"
        height="20"
        rx="10"
        fill="#0f172a"
        stroke="#4f46e5"
        strokeWidth="1"
        className="anim-float"
        style={{ animationDelay: "0.6s" }}
      />
      <text x="260" y="124" fill="#a5b4fc" fontSize="9" fontWeight="bold">
        Auto-Routed
      </text>

      <rect
        x="250"
        y="250"
        width="70"
        height="20"
        rx="10"
        fill="#0f172a"
        stroke="#4f46e5"
        strokeWidth="1"
        className="anim-float"
        style={{ animationDelay: "0.8s" }}
      />
      <text x="261" y="264" fill="#a5b4fc" fontSize="9" fontWeight="bold">
        Data Extracted
      </text>

      {/* Scanner Sweep */}
      <line
        x1="340"
        y1="140"
        x2="410"
        y2="140"
        stroke="#a5b4fc"
        strokeWidth="2"
        className={styles["anim-scanner"]}
        filter="url(#hero-glow)"
      />
    </svg>
  </div>
);

const EmailToCase = () => {
  return (
    <>
      <div className="product-page">
        {/* 1. HERO SECTION */}
        <section className="product-hero-dark">
          <div className="product-hero-mesh" />
          <div className={styles["product-hero-glow"]} />

          <div className="sec-container">
            <div className="product-hero-row">
              <motion.div
                className="product-hero-inner"
                variants={parentVariants}
                initial="hidden"
                animate="show"
              >
                <motion.div
                  className="product-eyebrow"
                  variants={childVariants}
                >
                  <span className="product-eyebrow-dot" /> AI-Powered Automation
                </motion.div>
                <motion.h1 className="product-h1" variants={childVariants}>
                  <span className="product-text-gradient">
                    Automated Document & Email
                  </span>
                  <br />
                  Processing for Modern Companies
                </motion.h1>
                <motion.p className="product-lead" variants={childVariants}>
                  Streamline your business operations with our intelligent
                  automation platform. Our service leverages advanced AI to
                  extract, classify, and process information from emails and
                  documents, helping companies of all sizes save time, reduce
                  errors, and focus on what matters most.
                </motion.p>
                <motion.div
                  className="product-cta-group"
                  variants={childVariants}
                >
                  <a
                    href="/contact"
                    className="product-btn product-btn-primary"
                  >
                    Contact Us for a Demo
                  </a>
                  {/* <a
                    href="/api-catalogue-home"
                    className="product-btn product-btn-outline"
                  >
                    Start in Sandbox
                  </a> */}
                </motion.div>
              </motion.div>

              <motion.div
                variants={parentVariants}
                initial="hidden"
                animate="show"
                style={{ flex: 1, width: "100%" }}
              >
                <EmailHeroArt />
              </motion.div>
            </div>
          </div>
        </section>

        {/* 2. PRODUCT STATS */}
        <section
          className="product-section product-section-alt"
          style={{ padding: "6.4rem 0" }}
        >
          <div className="sec-container">
            <div className="product-comp-grid">
              <div className="product-comp-card hover-scale">
                <p className="product-comp-val">95%</p>
                <p className="product-comp-label">Extraction Accuracy</p>
              </div>
              <div className="product-comp-card hover-scale">
                <p className="product-comp-val">10&times;</p>
                <p className="product-comp-label">Faster Processing</p>
              </div>
              <div className="product-comp-card hover-scale">
                <p className="product-comp-val">24/7</p>
                <p className="product-comp-label">Real-Time Monitoring</p>
              </div>
              <div className="product-comp-card hover-scale">
                <p className="product-comp-val">0</p>
                <p className="product-comp-label">Missed Documents</p>
              </div>
            </div>
          </div>
        </section>

        {/* 3. WHAT OUR SERVICE DOES */}
        <section className="product-section" id="features">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span className="product-section-eyebrow">
                What Our Service Does
              </span>
              <h2 className="gen-h2">
                Everything you need to automate document workflows
              </h2>
              <p className="gen-h2-sub">
                One platform to ingest, extract, classify, and route — across
                every channel and file type your business uses.
              </p>
            </motion.div>

            <motion.div
              className="product-grid-3"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div
                className={`product-card ${styles["hover-glow-primary"]}`}
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Link />
                </div>
                <h3 className="product-card-title">
                  Automatically ingest and process emails and attachments
                </h3>
                <p className="product-card-desc">
                  From multiple sources in real time.
                </p>
              </motion.div>

              <motion.div
                className={`product-card ${styles["hover-glow-primary"]}`}
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Graph />
                </div>
                <h3 className="product-card-title">
                  Extract structured data from unstructured text
                </h3>
                <p className="product-card-desc">
                  Names, amounts, addresses, case details, and more.
                </p>
              </motion.div>

              <motion.div
                className={`product-card ${styles["hover-glow-primary"]}`}
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Clock />
                </div>
                <h3 className="product-card-title">
                  Classify and route cases with high accuracy
                </h3>
                <p className="product-card-desc">
                  Finance, legal, technical, HR — automatically tagged and
                  directed.
                </p>
              </motion.div>

              <motion.div
                className={`product-card ${styles["hover-glow-primary"]}`}
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.FileText />
                </div>
                <h3 className="product-card-title">
                  Support for a wide variety of file types
                </h3>
                <p className="product-card-desc">
                  PDFs, images, and compressed archives.
                </p>
              </motion.div>

              <motion.div
                className={`product-card ${styles["hover-glow-primary"]}`}
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Laptop />
                </div>
                <h3 className="product-card-title">
                  Seamless integration via secure APIs
                </h3>
                <p className="product-card-desc">
                  Connect to your CRM, ERP, or workflow tools with minimal
                  setup.
                </p>
              </motion.div>

              <motion.div
                className={`product-card ${styles["hover-glow-primary"]}`}
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Shield />
                </div>
                <h3 className="product-card-title">
                  Real-time alerts and robust error handling
                </h3>
                <p className="product-card-desc">
                  Ensuring nothing is missed — every document is accounted for.
                </p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 4. WHY CHOOSE OUR SERVICE */}
        <section className="product-section product-section-alt">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span className="product-section-eyebrow">
                Why Choose Our Service?
              </span>
              <h2 className="gen-h2">
                Built for mission-critical document operations
              </h2>
              <p className="gen-h2-sub">
                Trusted by companies that can't afford errors, delays, or data
                loss in their document and email workflows.
              </p>
            </motion.div>

            <motion.div
              className="product-grid-3"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div
                className={`product-card ${styles["hover-glow-primary"]}`}
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Clock />
                </div>
                <h3 className="product-card-title">
                  Save Time & Reduce Manual Effort
                </h3>
                <p className="product-card-desc">
                  Automate repetitive, error-prone data entry and document
                  review tasks.
                </p>
              </motion.div>

              <motion.div
                className={`product-card ${styles["hover-glow-primary"]}`}
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Settings />
                </div>
                <h3 className="product-card-title">AI-Powered Accuracy</h3>
                <p className="product-card-desc">
                  Our extraction engine adapts to new formats and languages,
                  ensuring high-quality structured data.
                </p>
              </motion.div>

              <motion.div
                className={`product-card ${styles["hover-glow-primary"]}`}
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Shield />
                </div>
                <h3 className="product-card-title">End-to-End Security</h3>
                <p className="product-card-desc">
                  All data is processed securely, with encryption and strict
                  access controls.
                </p>
              </motion.div>

              <motion.div
                className={`product-card ${styles["hover-glow-primary"]}`}
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.TrendingUp />
                </div>
                <h3 className="product-card-title">Scalable & Reliable</h3>
                <p className="product-card-desc">
                  Designed for high-throughput environments, with robust error
                  handling, logging, and alerting.
                </p>
              </motion.div>

              <motion.div
                className={`product-card ${styles["hover-glow-primary"]}`}
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Settings />
                </div>
                <h3 className="product-card-title">Customizable Workflows</h3>
                <p className="product-card-desc">
                  Easily configure rules, case types, and integrations to fit
                  your business needs.
                </p>
              </motion.div>

              <motion.div
                className={`product-card ${styles["hover-glow-primary"]}`}
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.FileText />
                </div>
                <h3 className="product-card-title">Proven Results</h3>
                <p className="product-card-desc">
                  Trusted by companies for mission-critical document and email
                  processing.
                </p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 5. HOW IT WORKS */}
        <section className="product-section" id="how-it-works">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span className="product-section-eyebrow">How It Works</span>
              <h2 className="gen-h2">From inbox to insight in four steps</h2>
              <p className="gen-h2-sub">
                A simple, automated pipeline that handles the complexity so you
                don't have to.
              </p>
            </motion.div>

            <motion.div
              className="product-step-wrapper"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <div className="product-step-line" />
              <div className="product-grid-4">
                <motion.div className="product-step" variants={childVariants}>
                  <div className="product-step-icon-wrap">
                    <div className="product-step-icon-bg" />
                    <div className="product-step-icon">
                      <Icons.Inbox />
                    </div>
                    <div className="product-step-num">1</div>
                  </div>
                  <h3 className="product-card-title">Ingest</h3>
                  <p className="product-card-desc">
                    Emails and attachments are automatically collected from all
                    configured sources.
                  </p>
                </motion.div>
                <motion.div className="product-step" variants={childVariants}>
                  <div className="product-step-icon-wrap">
                    <div className="product-step-icon-bg" />
                    <div className="product-step-icon">
                      <Icons.Search />
                    </div>
                    <div className="product-step-num">2</div>
                  </div>
                  <h3 className="product-card-title">Extract</h3>
                  <p className="product-card-desc">
                    AI reads every document and pulls structured fields — no
                    matter the format.
                  </p>
                </motion.div>
                <motion.div className="product-step" variants={childVariants}>
                  <div className="product-step-icon-wrap">
                    <div className="product-step-icon-bg" />
                    <div className="product-step-icon">
                      <Icons.Tag />
                    </div>
                    <div className="product-step-num">3</div>
                  </div>
                  <h3 className="product-card-title">Classify</h3>
                  <p className="product-card-desc">
                    Cases are automatically tagged and routed to the correct
                    team or system.
                  </p>
                </motion.div>
                <motion.div className="product-step" variants={childVariants}>
                  <div className="product-step-icon-wrap">
                    <div className="product-step-icon-bg" />
                    <div className="product-step-icon">
                      <Icons.Send />
                    </div>
                    <div className="product-step-num">4</div>
                  </div>
                  <h3 className="product-card-title">Deliver</h3>
                  <p className="product-card-desc">
                    Structured results are pushed to your systems via API with
                    real-time alerts.
                  </p>
                </motion.div>
              </div>
            </motion.div>
          </div>
        </section>

        {/* 6. FINAL CTA (DARK) */}
        <section className="product-dark-cta">
          <div className="product-hero-ambient" />
          <div className="sec-container">
            <div
              className="product-cta-grid"
              style={{ gridTemplateColumns: "1fr", textAlign: "center" }}
            >
              <div
                style={{
                  maxWidth: "80rem",
                  margin: "0 auto",
                  position: "relative",
                  zIndex: 10,
                }}
              >
                <h2 className="product-h1" style={{ fontSize: "4.8rem" }}>
                  Ready to transform your
                  <br />
                  document and email workflows?
                </h2>
                <p className="product-lead" style={{ marginBottom: "4rem" }}>
                  Join forward-thinking companies already automating their
                  document and email processing. Get started with a demo or free
                  trial today.
                </p>
                <div
                  className="product-cta-group"
                  style={{ justifyContent: "center" }}
                >
                  <a
                    href="/contact"
                    className="product-btn product-btn-primary"
                    style={{ padding: "1.6rem 3.2rem" }}
                  >
                    Request a Free Demo
                  </a>
                  {/* <a
                    href="/api-catalogue-home"
                    className="product-btn product-btn-outline"
                    style={{ padding: "1.6rem 3.2rem" }}
                  >
                    Get Started
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default EmailToCase;
